// https://github.com/aws-amplify/amplify-cli/issues/2420

export const getOutboundShipment = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      shipWithGroupId
      shipWithIds
      hasException
      owner
      groups
      active
      status
      state
      gateCheckInId
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrierEquipmentTypeId
      carrierName
      bolNumber
      railCarNumber
      mustTarp
      skipSignature
      skipInvoice
      yardSignatureKey
      carrierSignatureKey
      signedBy
      containerPickup
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      tareWeight
      ladenWeight
      netWeight
      weightUnits
      scaleWeightUnits
      totalUOM
      billToAccountId
      areaId
      area {
        id
        active
        reloadYardId
        name
        prefix
        areaType
        color
        sortKey
      }
      zoneId
      trackCar {
        id
        active
        areaId
        zoneId
        aisleId
        trackId
        locationFullName
        sortKey
        location {
          id
          name
          type
          areaId
          area {
            id
            name
            prefix
            areaType
          }
          zoneId
          zone {
            id
            name
            prefix
            accountId
            zoneType
          }
          aisleId
          aisle {
            id
            name
            type
          }
        }
      }
      isCollected
      photos {
        items {
          id
          bucket
          region
          key
          name
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
      }
      bolFile {
        bucket
        region
        key
      }
      sealNumber
      seals {
        items {
          id
          active
          # reloadYardId
          # accountId
          # accountName
          # referenceId
          # referenceName
          barcode
          isScanned
          createdAt
          createdBy
          brokenAt
          brokenBy
          validated
          description
          updatedAt
        }
      }
      assignedTo
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      accountName
      accountId
      account {
        id
        groups # keep it
        active
        status
        lotNumberPrefix
        accountType
        defaultBillToAccountId
        businessName
        displayName
        reloadYardId
        lotType
        overDue
        overLimit
        outboundEventTypeId # scheduler: resolve default event type on edit
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        trackOutboundSeals
        verifyOutboundRailCar
        generatePickupNumber
        outboundSkipSignature
        inventoryCustomFields {
          id
          name
          type
          display
        }
        inventoryPrimaryField
        bolTemplate {
          bucket
          region
          key
          type
        }
      }
      billToAccount {
        businessName
        displayName
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          totalQuantityToPick
          totalQuantityReturned
          outboundShipmentId
          reloadYardId
          inventoryId
          sortKey
          inventory {
            id
            active
            groups
            reloadYardId
            status
            outboundShipmentId
            productName
            productCode
            productId
            product {
              id
              productCode
              defaultUOM
              defaultWeightUOM
              unit
              pcs
              mbf
              lf
              sf
              msf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
              ft
              m
              pcsHeight
              pcsWidth
              pcsLength
              # width
              # length
              # height
              # lowInventoryThreshold
              # totalInventoryQuantity
              # lowInventoryAlert
            }
            accountName
            accountId
            lotType
            lotNumber
            poNumber
            railCarNumber
            reloadYardCommodityId
            reloadYardCommodity {
              id
              reloadYardId
              commodityId
              units
              sortKey
              commodity {
                id
                name
                defaultUnits
                locationLoadType
              }
            }
            areaId
            zoneId
            receivedAt
            depletedAt
            lastOutboundId
            turnDays
            quantityAdvised
            quantityReceived
            quantityOnHand
            quantityCommitted
            quantityPhysical
            inventoryUOM
            pcs
            pcsHeight
            pcsWidth
            pcsLength
            weight
            weightUOM
            history {
              type
              date
              by
              text
            }
            customFields
            shipmentLineItems {
              items {
                outboundShipmentId
                outboundShipment {
                  departureDateTime
                }
              }
            }
            updatedAt
          }
          inventoryItems {
            items {
              id
              groups
              reloadYardId
              outboundShipmentId
              shipmentLineItemId
              inventoryItemId
              inventoryItem {
                id
                owner
                groups
                status
                quantityOnHand
                quantityCommitted
                hasException
                isDamaged
                originOfDamage
                otherException
                otherExceptionNote
                status
                depletedAt
                inventoryId
                inventory {
                  id
                  status
                  lotNumber
                  poNumber
                  railCarNumber
                  receivedAt
                  quantityAdvised
                  quantityReceived
                  quantityOnHand
                  quantityCommitted
                  inventoryUOM
                  weight
                  weightUOM
                  customFields
                }
                areaId
                area {
                  id
                  active
                  reloadYardId
                  name
                  prefix
                  areaType
                  sortKey
                }
                zoneId
                zone {
                  id
                  active
                  reloadYardId
                  name
                  prefix
                  accountId
                  areaId
                  color
                  zoneType
                  sortKey
                }
                aisleId
                locationId
                location {
                  createdAt
                  updatedAt
                  id
                  active
                  reloadYardId
                  name
                  type
                  productId
                  productName
                  areaId
                  zoneId
                  aisleId
                  bay
                  level
                  position
                  capacityUsed
                  capacityAllocated
                  length
                  width
                  sortKey
                  aisle {
                    id
                    owner
                    groups
                    active
                    reloadYardId
                    name
                    type
                    areaId
                    zoneId
                    sortKey
                    totalLocations
                  }
                  locationLoad {
                    other {
                      selected
                      capacity
                    }
                    pallet {
                      selected
                      capacity
                    }
                    box {
                      selected
                      capacity
                    }
                    container {
                      selected
                      capacity
                    }
                    superSack {
                      selected
                      capacity
                    }
                    dryBulk {
                      selected
                      capacity
                    }
                    liquidBulk {
                      selected
                      capacity
                    }
                  }
                }
                outboundShipmentId
                locationFullName
                latitude
                longitude
                reloadYardId
                history {
                  type
                  date
                  by
                  text
                }
                updatedAt
              }
              hasException
              barcodeException
              barcodeExceptionNote
              otherException
              otherExceptionNote
              quantityToPick
              quantityReturned
              loadedBy
              updatedAt
            }
            nextToken
          }
          history {
            type
            date
            by
            text
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        invoiceNumber
        outboundShipmentId
      }
      invoicedServices {
        items {
          itemTotal
        }
        nextToken
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        units
        sortKey
        commodity {
          id
          name
          defaultUnits
        }
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
      }
      timeslotId
      timeslot {
        id
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        outboundId
        accountName
        accountId
        eventTypeId
        eventType {
          id
          active
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          assetType {
            id
            maxConcurrentBookings
          }
          schedule {
            workdays {
              id
              name
              startDayTime
              endDayTime
              selected
            }
            minNoticeHours
            maxDaysIntoFuture
          }
        }
      }
      advisedBy
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      manualCharges {
        items {
          id
          quantity
          chargeRuleId
          chargeRule {
            id
            serviceId
            service {
              id
              name
              unit
              pcs
              car
              tl
              mbf
              lf
              sf
              msf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
              ft
              m
              taxRate {
                taxCode
                name
                taxRate
              }
            }
            billingUOM
            minCharge
            maxCharge
            execution
          }
          sortKey
          invoiceServiceId
        }
        nextToken
      }
      returnShipment
      returnReason
      inspectedBy
      trackCar {
        locationFullName
      }
      # createdAt
      updatedAt
    }
  }
`;

//###############################################
// LTL "ship with": the sibling projection every surface reads for a linked
// group (aside list, UNLINK guard, badge tooltip, carrier claim). One call per
// member id, so it stays narrow — header fields plus the consignee line,
// nothing nested.
//
// carrierId and carrierName are here for the carrier portal's claim: a claim
// stamps every member of the truck, and a member read by id has to be judged
// for ownership on the same terms as one the search returned (free, already
// this carrier's, or somebody else's). Without them every sibling read this
// way looked unclaimed, and a retry finishing a part-claimed truck refused its
// own loads.
//###############################################
export const getOutboundShipmentShipWith = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      status
      poNumber
      pickupNumber
      accountId
      reloadYardId
      carrierType
      carrierId
      carrierName
      transfer
      gateCheckInId
      scheduledDateTime
      timeslotId
      shipTo {
        name
        city
        state
      }
      shipWithGroupId
      shipWithIds
    }
  }
`;

export const getOutboundShipmentValidate = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      updatedAt
      shipmentLineItems {
        items {
          id
          updatedAt
          inventory {
            id
            updatedAt
          }
          inventoryItems {
            items {
              id
              updatedAt
              inventoryItem {
                id
                updatedAt
              }
            }
          }
        }
      }
    }
  }
`;

export const shipmentLineItemByInventoryForValidation = /* GraphQL */ `
  query ShipmentLineItemByInventory(
    $inventoryId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentLineItemByInventory(
      inventoryId: $inventoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        active
        status
        outboundShipment {
          id
          active
          status
          state
        }
      }
      nextToken
    }
  }
`;

export const getOutboundShipmentForInvoice = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      status
      state
      poNumber
      pickupNumber
      carrierType
      carrierEquipmentTypeId
      transfer
      transferToAccountId
      transferToAccountName
      railCarNumber
      placementDateTime
      departureDateTime
      collectedDateTime
      isCollected
      tareWeight
      ladenWeight
      netWeight
      weightUnits
      scaleWeightUnits
      totalUOM
      skipInvoice
      areaId
      area {
        areaType
      }
      zoneId
      history {
        type
        date
        by
        text
      }
      accountName
      accountId
      billToAccountId
      reloadYardId
      reloadYardCommodityId

      # needed for rule-based billing per area / zone / loadType
      shipmentLineItems {
        items {
          id
          totalQuantityToPick
          inventory {
            id
            status
            receivedAt
            depletedAt
            lastOutboundId
            quantityReceived
            quantityOnHand
            product {
              defaultUOM
              defaultWeightUOM
              unit
              pcs
              mbf
              lf
              sf
              msf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
              ft
              m
              pcsHeight
              pcsWidth
              pcsLength
            }
            reloadYardCommodityId
            areaId
            zoneId
            inventoryUOM
            pcs
            pcsHeight
            pcsWidth
            pcsLength
            weight
            weightUOM
            shipmentLineItems {
              items {
                outboundShipmentId
                createdAt
              }
            }
          }
        }
        nextToken
      }
      invoiceId
      invoice {
        invoiceNumber
      }
      invoicedServices {
        items {
          itemTotal
        }
        nextToken
      }
      manualCharges {
        items {
          id
          quantity
          chargeRule {
            id
            serviceId
            event
            frequency
            feeAccrual
            freeDays
            freeDaysPolicy
            graduatedRates {
              days
              rate
            }
            service {
              id
              name
              unit
              pcs
              car
              tl
              mbf
              lf
              sf
              msf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
              ft
              m
              taxRate {
                taxCode
                name
                taxRate
              }
            }
            billingUOM
            minCharge
            maxCharge
            execution
          }
        }
        nextToken
      }
    }
  }
`;

export const getOutboundShipmentForUpdate = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      shipWithGroupId
      shipWithIds
      active
      status
      state
      pickupNumber
      carrierType
      accountName
      accountId
      billToAccountId
      createDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      reloadYardId
      invoiceId
      history {
        type
        date
        by
        text
      }
    }
  }
`;

export const getOutboundShipmentForValidate = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      invoiceId
    }
  }
`;

//###############################################
// crewApp/outboundList
//###############################################
export const outboundShipmentByStatus = /* GraphQL */ `
  query OutboundShipmentByStatus(
    $reloadYardId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByStatus(
      reloadYardId: $reloadYardId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        createDateTime
        pickupNumber
        yardSignatureKey
        carrierSignatureKey
        carrierType
        carrierName
        bolNumber
        railCarNumber
        assignedTo
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        totalUOM
        areaId
        accountName
        accountId
        account {
          businessName
          displayName
          accountType
        }
        reloadYardId
        hasException
      }
      nextToken
    }
  }
`;

//###############################################
// crewApp/gateQueue
//###############################################
// Selection carries every member of the outbound composite sort keys
// (status, active, endDateTime, arrivalDateTime, scheduledDateTime,
// createDateTime) so ensureCompositeKeyFields can echo them on the
// placement update, plus history so the placement note appends instead
// of replacing.
export const outboundShipmentByStatusGateQueue = /* GraphQL */ `
  query OutboundShipmentByStatus(
    $reloadYardId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByStatus(
      reloadYardId: $reloadYardId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shipWithGroupId
        shipWithIds
        active
        status
        state
        transfer
        transferToAccountName
        poNumber
        pickupNumber
        carrierType
        carrierName
        railCarNumber
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        endDateTime
        history {
          type
          date
          by
          text
        }
        accountName
        accountId
        reloadYardId
      }
      nextToken
    }
  }
`;

//###############################################
// gateCheckIns: placing one shipment from the gate check-in control.
// Carries every composite sort-key member so ensureCompositeKeyFields can echo
// them, plus the stamps that say whether placement already happened.
//###############################################
export const getOutboundShipmentGatePlacement = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      shipWithGroupId
      shipWithIds
      poNumber
      active
      status
      state
      gateCheckInId
      carrierType
      carrierName
      railCarNumber
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      history {
        type
        date
        by
        text
      }
      accountId
      reloadYardId
    }
  }
`;

export const outboundShipmentByStatusOptions = /* GraphQL */ `
  query OutboundShipmentByStatus(
    $reloadYardId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByStatus(
      reloadYardId: $reloadYardId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        poNumber
        pickupNumber
        accountName
        reloadYardId
        status
        active
        endDateTime
        arrivalDateTime
        placementDateTime
        scheduledDateTime
        createDateTime
      }
    }
  }
`;

//###############################################
// managerApp/outboundList
//###############################################
export const outboundShipmentByReloadYardByStatusByDates = /* GraphQL */ `
  query OutboundShipmentByReloadYardByStatusByDates(
    $reloadYardId: ID
    $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: ModelOutboundShipmentOutboundShipmentByReloadYardByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByReloadYardByStatusByDates(
      reloadYardId: $reloadYardId
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        createdAt
        shipWithGroupId
        shipWithIds
        transfer
        gateCheckInId
        timeslotId
        status
        state
        transferToAccountName
        hasException
        poNumber
        pickupNumber
        # The whole Address, never a subset: a list row lands in the admin
        # store, seeds the edit form, and a refresh of this list while that
        # form is open writes its shipTo back over the form's. A projection
        # narrower than the Address saves a partial one, and Address.street,
        # city, state, zipCode and country are non-null — one partial address
        # makes getOutboundShipment fail outright ("Element does not exist").
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierName
        bolNumber
        carrierType
        railCarNumber
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        isCollected
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        totalUOM
        skipInvoice
        billToAccountId
        assignedTo
        accountName
        accountId
        account {
          id
          businessName
          displayName
          accountType
        }
        reloadYardId
        areaId
        shipmentLineItems {
          items {
            id
            status
            lotNumber
            totalQuantityToPick
            inventoryId
            inventory {
              id
              productCode
              productName
            }
            inventoryItems {
              items {
                inventoryItem {
                  id
                  quantityOnHand
                  quantityCommitted
                  status
                  locationFullName
                  location {
                    id
                    type
                  }
                }
                quantityToPick
                quantityReturned
                status
              }
              nextToken
            }
          }
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        returnShipment
      }
      nextToken
    }
  }
`;

//###############################################
// carrierApp/outboundList
//###############################################
export const outboundShipmentByCarrierByStatusByDates = /* GraphQL */ `
  query OutboundShipmentByCarrierByStatusByDates(
    $carrierId: ID
    $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: ModelOutboundShipmentOutboundShipmentByCarrierByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByCarrierByStatusByDates(
      carrierId: $carrierId
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        createdAt
        shipWithGroupId
        shipWithIds
        transfer
        gateCheckInId
        timeslotId
        status
        state
        transferToAccountName
        hasException
        poNumber
        pickupNumber
        # The whole Address, never a subset: a list row lands in the admin
        # store, seeds the edit form, and a refresh of this list while that
        # form is open writes its shipTo back over the form's. A projection
        # narrower than the Address saves a partial one, and Address.street,
        # city, state, zipCode and country are non-null — one partial address
        # makes getOutboundShipment fail outright ("Element does not exist").
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierName
        carrierId
        driverId
        driverName
        bolNumber
        carrierType
        railCarNumber
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        totalUOM
        skipInvoice
        billToAccountId
        assignedTo
        accountName
        accountId
        account {
          id
          businessName
          displayName
          accountType
        }
        reloadYardId
        shipmentLineItems {
          items {
            id
            status
            lotNumber
            totalQuantityToPick
            inventoryId
            inventory {
              id
              productCode
              productName
            }
          }
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        returnShipment
      }
      nextToken
    }
  }
`;

//###############################################
// customerApp/outboundList
//###############################################
export const outboundShipmentByAccountByStatusByDates = /* GraphQL */ `
  query OutboundShipmentByAccountByStatusByDates(
    $accountId: ID
    $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: ModelOutboundShipmentOutboundShipmentByAccountByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByAccountByStatusByDates(
      accountId: $accountId
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        createdAt
        shipWithGroupId
        shipWithIds
        transfer
        gateCheckInId
        timeslotId
        status
        state
        transferToAccountName
        hasException
        poNumber
        pickupNumber
        # The whole Address, never a subset: a list row lands in the admin
        # store, seeds the edit form, and a refresh of this list while that
        # form is open writes its shipTo back over the form's. A projection
        # narrower than the Address saves a partial one, and Address.street,
        # city, state, zipCode and country are non-null — one partial address
        # makes getOutboundShipment fail outright ("Element does not exist").
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierName
        bolNumber
        carrierType
        railCarNumber
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        totalUOM
        skipInvoice
        billToAccountId
        assignedTo
        accountName
        accountId
        account {
          id
          businessName
          displayName
          accountType
        }
        reloadYardId
        shipmentLineItems {
          items {
            id
            status
            lotNumber
            totalQuantityToPick
            inventoryId
            inventory {
              id
              productCode
              productName
            }
            inventoryItems {
              items {
                inventoryItem {
                  id
                  quantityOnHand
                  quantityCommitted
                  status
                  locationFullName
                  location {
                    id
                    type
                  }
                }
                quantityToPick
                quantityReturned
                status
              }
              nextToken
            }
          }
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        returnShipment
      }
      nextToken
    }
  }
`;

export const searchOutboundShipments = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        createdAt
        shipWithGroupId
        shipWithIds
        gateCheckInId
        timeslotId
        status
        state
        transfer
        transferToAccountId
        hasException
        transferToAccountName
        poNumber
        pickupNumber
        # The whole Address, never a subset: a list row lands in the admin
        # store, seeds the edit form, and a refresh of this list while that
        # form is open writes its shipTo back over the form's. A projection
        # narrower than the Address saves a partial one, and Address.street,
        # city, state, zipCode and country are non-null — one partial address
        # makes getOutboundShipment fail outright ("Element does not exist").
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrierName
        carrierId
        bolNumber
        railCarNumber
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        endDateTime
        departureDateTime
        daysOnDemurrageClock
        customFields
        totalUOM
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        skipInvoice
        billToAccountId
        assignedTo
        areaId
        zoneId
        isCollected
        reloadYardCommodityId
        accountName
        accountId
        account {
          businessName
          displayName
          accountType
        }
        trackCar {
          id
          trackId
          locationFullName
        }
        reloadYardId
        shipmentLineItems {
          items {
            id
            status
            lotNumber
            totalQuantityToPick
            totalQuantityReturned
            inventoryId
            inventory {
              id
              productId
              productCode
              productName
              inventoryUOM
            }
            inventoryItems {
              items {
                inventoryItem {
                  id
                  quantityOnHand
                  quantityCommitted
                  status
                  locationFullName
                }
                quantityToPick
                quantityReturned
                status
              }
              nextToken
            }
          }
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        returnShipment
        returnReason
      }
      nextToken
      total
    }
  }
`;

export const searchOutboundShipmentsDropDown = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        railCarNumber
        accountName
        trackCar {
          id
          trackId
        }
      }
      nextToken
      total
    }
  }
`;

export const countOutboundShipments = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      total
    }
  }
`;

export const getShipmentLineItem = /* GraphQL */ `
  query GetShipmentLineItem($id: ID!) {
    getShipmentLineItem(id: $id) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      outboundShipmentId
      outboundShipment {
        id
        # invoiceId
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        lotType
        areaId
        zoneId
        outboundShipmentId
        notes {
          type
          date
          by
          text
        }
        history {
          type
          date
          by
          text
        }
        productName
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          width
          length
          height
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          # owner
          groups
          active
          status
          externalId
          lotNumberPrefix
          businessName
          displayName
          accountType
          defaultWeightUOM
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          carrierName
          lotType
          railCarNumber
          totalUOM
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          instructions
          accountName
          accountId
          reloadYardId
          # invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          customFields
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          commodity {
            id
            name
            defaultUnits
          }
          # owner
          # groups
          # active
          # verified
          units
          sortKey
          # createdAt
          # updatedAt
        }
        customFields
        # createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          shipmentLineItemId
          inventoryItemId
          inventoryItem {
            id
            owner
            groups
            quantityOnHand
            quantityCommitted
            hasException
            isDamaged
            originOfDamage
            otherException
            otherExceptionNote
            status
            depletedAt
            inventoryId
            inventory {
              id
              owner
              groups
              active
              status
              lotNumber
              poNumber
              railCarNumber
              receivedAt
              depletedAt
              turnDays
              quantityAdvised
              quantityReceived
              quantityOnHand
              quantityPhysical
              quantityCommitted
              quantityMismatch
              inventoryUOM
              weight
              weightUOM
              verificationRequired
              hasException
              overShipment
              overShipmentQuantity
              overShipmentNote
              underShipment
              underShipmentQuantity
              underShipmentNote
              isDamaged
              isRecalled
              recallNote
              otherException
              otherExceptionNote
              lotType
              areaId
              zoneId
              aisleList
              # outboundShipmentId
              # latitude
              # longitude
              productName
              productCode
              productId
              sortKey
              accountName
              accountId
              reloadYardId
              inboundShipmentId
              auditId
              reloadYardCommodityId
              customFields
              createdAt
              updatedAt
            }
            areaId
            area {
              id
              owner
              groups
              active
              reloadYardId
              name
              prefix
              color
              areaType
              sortKey
              createdAt
              updatedAt
            }
            zoneId
            zone {
              id
              owner
              groups
              active
              reloadYardId
              name
              prefix
              accountId
              areaId
              color
              zoneType
              sortKey
              createdAt
              updatedAt
            }
            aisleId
            locationId
            location {
              id
              owner
              groups
              active
              reloadYardId
              name
              type
              areaId
              zoneId
              aisleId
              bay
              level
              position
              capacityUsed
              capacityAllocated
              length
              width
              sortKey
              createdAt
              updatedAt
            }
            history {
              type
              date
              by
              text
            }
            outboundShipmentId
            locationFullName
            latitude
            longitude
            reloadYardId
            # createdAt
            updatedAt
          }
          quantityToPick
          status
          # createdAt
          updatedAt
        }
        nextToken
      }
      # createdAt
      updatedAt
    }
  }
`;

export const getShipmentLineItemValidate = /* GraphQL */ `
  query GetShipmentLineItem($id: ID!) {
    getShipmentLineItem(id: $id) {
      id
      inventory {
        id
        updatedAt
      }
      outboundShipment {
        id
        updatedAt
      }
      inventoryItems {
        items {
          id
          inventoryItem {
            id
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;

export const getOutboundShipmentMobile = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      owner
      status
      state
      active
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
      }
      carrierType
      carrierName
      bolNumber
      railCarNumber
      mustTarp
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      tareWeight
      ladenWeight
      netWeight
      weightUnits
      scaleWeightUnits
      totalUOM
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      isCollected
      sealNumber
      assignedTo
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      accountName
      accountId
      account {
        id
        lotNumberPrefix
        businessName
        displayName
        reloadYardId
        trackInboundSeals
        trackOutboundSeals
        verifyInboundRailCar
        verifyOutboundRailCar
        outboundCustomFields {
          id
          name
          type
          display
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        outboundSkipSignature
        outboundPhotos
        outboundReview
        inventoryCustomFields {
          id
          name
          type
          display
        }
        inventoryPrimaryField
        bolTemplate {
          bucket
          region
          key
          type
        }
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          totalQuantityToPick
          outboundShipmentId
          reloadYardId
          inventoryId
          sortKey
          inventory {
            id
            active
            groups
            reloadYardId
            status
            outboundShipmentId
            productName
            productCode
            productId
            product {
              id
              category
              name
              productCode
              defaultUOM
              defaultWeightUOM
              unit
            }
            accountName
            accountId
            lotType
            lotNumber
            poNumber
            reloadYardCommodity {
              id
              reloadYardId
              commodityId
              units
              sortKey
              commodity {
                id
                name
                defaultUnits
                locationLoadType
              }
            }
            # photos {
            #   bucket
            #   region
            #   key
            # }
            receivedAt
            depletedAt
            turnDays
            quantityOnHand
            quantityAdvised
            quantityReceived
            quantityCommitted
            quantityPhysical
            inventoryUOM
            weight
            weightUOM
            notes {
              type
              date
              by
              text
              public
            }
            history {
              type
              date
              by
              text
            }
            customFields
          }
          inventoryItems {
            items {
              id
              status
              outboundShipmentId
              shipmentLineItemId
              inventoryItemId
              inventoryItem {
                id
                quantityOnHand
                quantityCommitted
                status
                depletedAt
                inventoryId
                inventory {
                  id
                  owner
                  groups
                  active
                  status
                  lotNumber
                  poNumber
                  railCarNumber
                  receivedAt
                  depletedAt
                  lastOutboundId
                  turnDays
                  quantityAdvised
                  quantityReceived
                  quantityOnHand
                  quantityPhysical
                  quantityCommitted
                  quantityMismatch
                  inventoryUOM
                  weight
                  weightUOM
                  verificationRequired
                  hasException
                  overShipment
                  overShipmentQuantity
                  overShipmentNote
                  underShipment
                  underShipmentQuantity
                  underShipmentNote
                  isDamaged
                  isRecalled
                  recallNote
                  otherException
                  otherExceptionNote
                  lotType
                  aisleList
                  outboundShipmentId
                  productName
                  productCode
                  productId
                  sortKey
                  accountName
                  accountId
                  reloadYardId
                  inboundShipmentId
                  auditId
                  reloadYardCommodityId
                  customFields
                }
                location {
                  id
                  owner
                  groups
                  active
                  reloadYardId
                  name
                  type
                  capacityUsed
                  capacityAllocated
                  productId
                  locationLoad {
                    other {
                      selected
                      capacity
                    }
                    pallet {
                      selected
                      capacity
                    }
                    box {
                      selected
                      capacity
                    }
                    container {
                      selected
                      capacity
                    }
                    superSack {
                      selected
                      capacity
                    }
                    dryBulk {
                      selected
                      capacity
                    }
                    liquidBulk {
                      selected
                      capacity
                    }
                  }
                  areaId
                  area {
                    id
                    active
                    reloadYardId
                    name
                    prefix
                    areaType
                    sortKey
                  }
                  zoneId
                  zone {
                    id
                    active
                    reloadYardId
                    name
                    prefix
                    accountId
                    areaId
                    sortKey
                  }
                  aisleId
                  aisle {
                    id
                    name
                    type
                    areaId
                    zoneId
                    bays
                    levels
                    capacityUsed
                    length
                    width
                    sortKey
                    topDownPickOrder
                  }
                  bay
                  level
                  position
                  length
                  width
                  sortKey
                }
                outboundShipmentId
                locationFullName
                reloadYardId
              }
              quantityToPick
              hasException
              barcodeException
            }
            nextToken
          }
          notes {
            type
            date
            by
            text
            public
          }
          history {
            type
            date
            by
            text
          }
        }
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        units
        sortKey
        commodity {
          id
          name
          defaultUnits
        }
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
      }
      trackCar {
        id
        active
        areaId
        zoneId
        aisleId
        trackId
        locationFullName
        sortKey
        location {
          id
          name
          type
          area {
            prefix
            areaType
          }
          zone {
            prefix
          }
          aisle {
            name
            type
          }
        }
      }
    }
  }
`;

export const getShipmentLineItemInventoryItemMobile = /* GraphQL */ `
  query GetShipmentLineItemInventoryItem($id: ID!) {
    getShipmentLineItemInventoryItem(id: $id) {
      id
      inventoryItemId
      shipmentLineItemId
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      scannedOut
      loadedBy
      inventoryItem {
        id
        barcode
        quantityOnHand
        quantityCommitted
        inventoryId
        inventory {
          id
          active
          status
          containerNumber
          lotNumber
          poNumber
          railCarNumber
          receivedAt
          depletedAt
          turnDays
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          weight
          weightUOM
          lotType
          areaId
          zoneId
          aisleList
          outboundShipmentId
          productName
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          auditId
          reloadYardCommodityId
          customFields
        }
        areaId
        zoneId
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          name
          containerNumber
          type
          areaId
          area {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            color
            areaType
            sortKey
          }
          zoneId
          zone {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            accountId
            areaId
            color
            zoneType
            sortKey
          }
          aisleId
          aisle {
            id
            owner
            groups
            active
            reloadYardId
            name
            type
            areaId
            zoneId
            bays
            levels
            capacityUsed
            topDownPickOrder
            length
            width
            sortKey
          }
          bay
          level
          position
          capacityUsed
          capacityAllocated
          length
          width
          sortKey
          locationLoad {
            other {
              selected
              capacity
            }
            pallet {
              selected
              capacity
            }
            box {
              selected
              capacity
            }
            container {
              selected
              capacity
            }
            superSack {
              selected
              capacity
            }
            dryBulk {
              selected
              capacity
            }
            liquidBulk {
              selected
              capacity
            }
          }
          productId
          # tags {
          #   nextToken
          # }
        }
        outboundShipmentId
        locationFullName
      }
      quantityToPick
      status
    }
  }
`;

export const getShipmentLineItemLookup = /* GraphQL */ `
  query GetShipmentLineItem($id: ID!) {
    getShipmentLineItem(id: $id) {
      id
      sortKey
      lotNumber
      totalQuantityToPick
      totalQuantityReturned
      status
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      # pickupPhoto {
      #   bucket
      #   region
      #   key
      #   type
      #   createdBy
      #   createdAt
      # }
      outboundShipmentId
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        lotNumber
        poNumber
        railCarNumber
        containerNumber
        receivedAt
        depletedAt
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        pcs
        verificationRequired
        lotType
        areaId
        zoneId
        outboundShipmentId
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
        }
        productName
        productCode
        productId
        product {
          id
          active
          accountId
          reloadYardId
          name
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          status
          # externalId
          lotNumberPrefix
          businessName
          displayName
          defaultWeightUOM
          trackInboundSeals
          trackInventorySeals
          verifyOutboundRailCar
          verifyInboundRailCar
          email
          # phone
          # fax
          # website
          billingEmail
          reloadYardId
          outboundInstructions
          posEmail
          secondaryReview
        }
        reloadYardId
        inboundShipmentId
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          commodity {
            id
            name
            defaultUnits
            locationLoadType
          }
          active
          verified
          units
          sortKey
        }
        customFields
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          shipmentLineItemId
          inventoryItemId
          inventoryItem {
            id
            owner
            groups
            quantityOnHand
            quantityCommitted
            inventoryId
            seals {
              items {
                id
                active
                reloadYardId
                accountId
                accountName
                referenceId
                referenceName
                barcode
                isScanned
                createdAt
                createdBy
                owner
                brokenAt
                brokenBy
                validated
                description
                updatedAt
              }
            }
            inventory {
              id
              active
              status
              lotNumber
              poNumber
              railCarNumber
              containerNumber
              receivedAt
              depletedAt
              turnDays
              quantityAdvised
              quantityReceived
              quantityOnHand
              quantityPhysical
              quantityCommitted
              quantityMismatch
              inventoryUOM
              weight
              weightUOM
              verificationRequired
              lotType
              aisleList
              outboundShipmentId
              productName
              productCode
              productId
              sortKey
              accountName
              accountId
              reloadYardId
              inboundShipmentId
              auditId
              reloadYardCommodityId
              customFields
            }
            outboundShipmentId
            locationFullName
            latitude
            longitude
            reloadYardId
            createdAt
            updatedAt
          }
          quantityToPick
        }
      }
    }
  }
`;

export const getOutboundShipmentTimeline = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      status
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
      }
      carrierType
      carrierName
      bolNumber
      railCarNumber
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      totalUOM
      sealNumber
      assignedTo
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      shipmentLineItems {
        items {
          id
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
        }
      }
      invoiceId
      createdAt
    }
  }
`;

export const shipmentLineItemByInventoryTimeline = /* GraphQL */ `
  query ShipmentLineItemByInventory(
    $inventoryId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentLineItemByInventory(
      inventoryId: $inventoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        sortKey
        lotNumber
        poNumber
        totalQuantityToPick
        totalQuantityReturned
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
        }
        outboundShipmentId
        outboundShipment {
          id
          poNumber
          pickupNumber
          carrierType
          carrierName
          bolNumber
          railCarNumber
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          ladenWeight
          totalUOM
          accountName
          invoiceId
          customFields
        }
        inventoryItems {
          items {
            id
            inventoryId
            quantityToPick
            quantityReturned
            status
            inventoryItem {
              id
              quantityOnHand
              quantityCommitted
              status
              locationFullName
            }
          }
        }
      }
    }
  }
`;

// Track Management pulls a car with a payload that carries no history; this
// reads just what the "Time Pulled" note appends to. Kept lean on purpose:
// no nested non-null field can reject the read and cost the note.
export const getOutboundShipmentTimePulled = /* GraphQL */ `
  query GetOutboundShipmentTimePulled($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      collectedDateTime
      history {
        type
        date
        by
        text
      }
    }
  }
`;
